import React, { useEffect, useState } from 'react'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './verifyEmail.css'
import queryString from 'query-string'
import { useNavigate } from 'react-router-dom'
import { ENDPOINT } from '../../helpers/Helper'
import axios from 'axios'

function VerifyEmail() {
    const navigate = useNavigate();

    useEffect(() => {
        const { token } = queryString.parse(window.location.search);

        axios.post(`${ENDPOINT}/auth/verify-email`, { "verifytoken": token })
            .then(res => {
                navigate("/")
            })
            .catch(err => {
                navigate("/error")
            })
            
    }, [window.location.search])

    return (
        <div className='verifyEmail'>
            <Navigation background="theme-color" logo='https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png' />

            <div className='main-section'>
                <div className='section-1'>
                    <img src="https://res.cloudinary.com/emacon-production/image/upload/v1638363592/the-outlet/Artboard_7_copy_3png_cyyl9i.png" />
                </div>
                <h3 style={{ textAlign: "center", fontWeight: "bold"}}>THANK YOU FOR VERIFING YOUR EMAIL ADDRESS</h3>
                <p style={{ textAlign: "center" }}>
                    Your email address has been successfully verified
                </p>
            </div>

            <Footer/>
        </div>
    )
}

export default VerifyEmail
